import * as ex from 'excalibur';
import { GridPosition } from '../types/interfaces';
import { TileType } from '../types/enums';

// Game configuration
export const TILE_SIZE = 16; // Changed to 16x16 for sprites
export const GRID_WIDTH = 60; // Increased from 30
export const GRID_HEIGHT = 40; // Increased from 20
export const WORLD_WIDTH = GRID_WIDTH * TILE_SIZE;
export const WORLD_HEIGHT = GRID_HEIGHT * TILE_SIZE;
export const CAMERA_SPEED = 200; // pixels per second

// Direction constants
export const DIRECTIONS = {
  UP: { x: 0, y: -1 },
  DOWN: { x: 0, y: 1 },
  LEFT: { x: -1, y: 0 },
  RIGHT: { x: 1, y: 0 }
};

// Get all 8 directions including diagonals
export const getAllDirections = (): GridPosition[] => [
  DIRECTIONS.UP,
  DIRECTIONS.DOWN,
  DIRECTIONS.LEFT,
  DIRECTIONS.RIGHT,
  { x: -1, y: -1 }, // UP-LEFT
  { x: 1, y: -1 },  // UP-RIGHT
  { x: -1, y: 1 },  // DOWN-LEFT
  { x: 1, y: 1 }    // DOWN-RIGHT
];

// Animation configuration
export const ANIMATION_DURATION = 150; // Animation duration in milliseconds
export const DEBUG_COLOR = ex.Color.fromHex('#ffcc0033'); // Yellow with transparency for cell examination highlights

// Tile properties
export const TILE_PROPERTIES = {
  [TileType.Grass]: { 
    walkable: true, 
    movementCost: 1,
    color: ex.Color.fromHex('#90EE9033')  // Light green with 0.2 opacity
  },
  [TileType.Water]: { 
    walkable: false, // Not walkable for land animals
    fishWalkable: true, // But fish can move in water
    movementCost: 0,
    color: ex.Color.fromHex('#87CEFA33')  // Light sky blue with 0.2 opacity
  },
  [TileType.Forest]: { 
    walkable: true, 
    movementCost: 2,
    color: ex.Color.fromHex('#228B2233')  // Forest green with 0.2 opacity
  },
  [TileType.Mountain]: { 
    walkable: false, 
    movementCost: 0,
    color: ex.Color.fromHex('#A9A9A933')  // Dark gray with 0.2 opacity
  },
  [TileType.Path]: { 
    walkable: true, 
    movementCost: 0.5,
    color: ex.Color.fromHex('#DEB88733')  // Burlywood (light brown) with 0.2 opacity
  }
};

// Entity movement speeds (milliseconds between moves)
export const MOVEMENT_SPEEDS = {
  VERY_SLOW: 5000,  // Move every 5 seconds
  SLOW: 3000,       // Move every 3 seconds
  NORMAL: 2000,     // Move every 2 seconds
  FAST: 1000,       // Move every 1 second
  VERY_FAST: 500    // Move every 0.5 seconds
};